import { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import AyuraAIlogo from "../Assests/images/Logo 4.png";
import Loader from './loader'
import InfoIcon from '@mui/icons-material/Info';
import { useLocation } from "react-router-dom";
import { IconButton, Tooltip, Typography, List, ListItem, ClickAwayListener } from '@mui/material';

const HealthForm = () => {

    const location = useLocation();

    const [openTooltipIndex, setOpenTooltipIndex] = useState(null);

    const [formData, setFormData] = useState({
        fullName: "",
        contactNumber: "",
        symptoms: "",
        healthFocus: "",
        wellnessAreas: [],
        otherWellness: "",
        placeOfVisit: "",
    });

    const wellnessItems =
        [
            {
                "name": "Energy & Weight Issues",
                "description": "For those feeling tired, sluggish, or struggling with weight",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Energy+%26+Weight+Issues.png",
                "selected": false,
                "sub_categories": [
                    "Fatigue & Low Energy",
                    "Unexplained Weight Gain/Loss",
                    "Blood Sugar Imbalances (Pre-diabetes, Diabetes)",
                    "Thyroid Issues (Hypothyroidism, Hyperthyroidism)",
                    "Cravings & Emotional Eating",
                    "Water Retention & Swelling",
                    "Slow Digestion & Weak Metabolism (Agni Imbalance)"
                ]
            },
            {
                "name": "Gut & Digestion",
                "description": "For those with stomach discomfort, bloating, or irregular digestion",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Gut+%26+Digestive+Health.png",
                "selected": false,
                "sub_categories": [
                    "Gas, Bloating & Indigestion",
                    "Acid Reflux & Heartburn",
                    "Constipation or Diarrhea",
                    "Gut Microbiome Imbalance",
                    "Food Sensitivities & Intolerances",
                    "Irritable Bowel Syndrome (IBS) & Gut Sensitivity (gut sensitivity, Gut Irritation)",
                    "Liver Health & Detox Issues (Fatty Liver, Toxins Overload)"
                ]
            },
            {
                "name": "Stress, Sleep & Mental Issues",
                "description": "For those struggling with stress, sleep, and emotional balance",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Stress%2C+Sleep+%26++Mental+Well-Being.png",
                "selected": false,
                "sub_categories": [
                    "Chronic Stress & Anxiety",
                    "Sleep Disorders (Insomnia, Poor Sleep Quality)",
                    "Brain Fog & Lack of Focus",
                    "Low Mood & Emotional Imbalances",
                    "Headaches & Migraines",
                    "Overthinking & Racing Thoughts",
                    "Dizziness & Lightheadedness"
                ]
            },
            {
                "name": "Hormonal, Men & Women's Health",
                "description": "For hormone-related issues, menstrual & reproductive health",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Hormonal%2C+Men+%26+Women%E2%80%99s++Wellness.png",
                "selected": false,
                "sub_categories": [
                    "PCOS & Irregular Periods",
                    "Menstrual Cramps & PMS",
                    "Menopause Symptoms (Hot Flashes, Mood Swings)",
                    "Thyroid Issues",
                    "Low Libido & Reproductive Health",
                    "Hormonal Acne & Skin Issues",
                    "Breast Tenderness & Fibrocystic Breasts"
                ]
            },
            {
                "name": "Joint & Muscle Recovery",
                "description": "For those with body aches, joint pain, or chronic inflammation",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Joint+%26+Muscle+Wellness.png",
                "selected": false,
                "sub_categories": [
                    "Joint Pain & Stiffness",
                    "Muscle Aches & Fatigue",
                    "Chronic Inflammation",
                    "Back, Neck & Shoulder Pain",
                    "Tingling & Numbness in Hands/Feet (Circulation & Nerve Issues)",
                    "Autoimmune-related symptoms"
                ]
            },
            {
                "name": "Skin & hair",
                "description": "For those dealing with frequent infections, allergies, skin or hair problems",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Skin+%26+Hair+Health.png",
                "selected": false,
                "sub_categories": [
                    "Seasonal & Food Allergies",
                    "Skin Conditions (Eczema, Psoriasis, Rashes)",
                    "Hair Fall & Premature Graying",
                    "Allergies & Skin Sensitivities",
                    "Frequent Colds, Cough, & Weak Immunity",
                    "Chronic Sinus Issues & Respiratory Issues",
                    "Dust Allergy"
                ]
            },

            {
                "name": "Respiratory & Immunity Issues",
                "description": "For those who frequently get sick, struggle with allergies or have breathing problems",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Respiratory+%26+Immune+Health.png",
                "selected": false,
                "sub_categories": [
                    "Common Cold (Runny Nose & Sneezing)",
                    "Asthma (Breathing Trouble & Wheezing)",
                    "Bronchitis (Persistent Cough & Mucus)",
                    "Sinusitis (Blocked Nose & Headache)",
                    "Pneumonia (Severe Cough & Chest Pain)",
                    "Allergies (Sneezing & Itchy Eyes)",
                ]
            },
            {
                "name": "Other",
                "description": "For any other health concerns not listed above",
                "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/General_wellness.png",
                "selected": false,
                "sub_categories": []
            }
        ]

    const wellnessOptionIcons = {
        "Energy and weight issues": "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Metabolic.png",
        "Gut & digestive wellness": "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Gastro.png",
        "Stress, sleep & mental wellness": "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Mental.png",
        "Joint & muscle wellness": "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Physical.png",
        "Skin & hair wellness": "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Hair+%26amp%3B+Skin.png",
        "Respiratory & immune wellness": "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Respiratoty.png",
        "Other": "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/General_wellness.png"
    };

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const handleTooltipOpen = (index) => {
        setOpenTooltipIndex(index);
    };

    const handleTooltipClose = () => {
        setOpenTooltipIndex(null);
    };

    useEffect(() => {

        const queryParams = new URLSearchParams(location.search);

        const placeOfVisit = queryParams.get('location') || '';

        setFormData((prevData) => ({
            ...prevData,
            placeOfVisit: placeOfVisit
        }));

    }, [location]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "wellnessAreas") {
            const updated = checked
                ? [...formData.wellnessAreas, value]
                : formData.wellnessAreas.filter((item) => item !== value);
            setFormData({ ...formData, wellnessAreas: updated });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { fullName, contactNumber, healthFocus } = formData;

        if (!fullName.trim() || !contactNumber.trim() || !healthFocus.trim()) {
            if (!fullName.trim()) {
                toast.error("Please enter Full Name.");
            }
            if (!contactNumber.trim()) {
                toast.error("Please enter Contact Number/Email.");
            }
            if (!healthFocus.trim()) {
                toast.error("Please enter Health Focus.");
            }
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post("https://api.profile.ayurai.in/submit", formData);
            toast.success("Form submitted successfully! We’ll contact you shortly!.");
            navigate("/success");
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("Something went wrong.");
            setLoading(false);
        }
    };

    const CorporatePlaces = {
        "Genotypic": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/genotypelogo.png"
    };

    return (
        <div>

            {loading && <Loader />}

            <form onSubmit={handleSubmit} className="ayurveda-health-form mx-auto p-14 bg-white rounded-lg shadow-md">
                <div className="flex items-center justify-between">
                    <div className="navbar-logo mb-4 flex items-center justify-between">
                        <img src={AyuraAIlogo} alt="Logo" />

                    </div>
                    <div className="navbar-logo mb-4 flex items-center justify-between">

                        {
                            formData.placeOfVisit && CorporatePlaces[formData.placeOfVisit] && (
                                <img
                                    src={CorporatePlaces[formData.placeOfVisit]}

                                    className="corporate-logo"
                                />
                            )
                        }
                    </div>
                </div>

                <div className="complete-form">

                    <h1 className="form-title">AIWELL Health Transformation Program</h1>
                    <h5 className="form-subtitle">Express Your Interest</h5>
                    <a
                        href="https://aiwell.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="explore-content"
                    >
                        Know More About AIWELL
                    </a>


                    <div className="mb-4">
                        <label className="form-question">
                            1. What is your health focus?
                        </label>
                        <div className="">
                            <label className="form-answer ">
                                <input
                                    type="radio"
                                    name="healthFocus"
                                    value="Optimize well-being"
                                    onChange={handleChange}
                                    checked={formData.healthFocus === "Optimize well-being"}
                                    className="form-radio"
                                />
                                <span className="pl-2">I want to optimize my well-being</span>
                            </label>
                            <br />
                            <label className="form-answer">
                                <input
                                    type="radio"
                                    name="healthFocus"
                                    value="Support for health concern"
                                    onChange={handleChange}
                                    checked={formData.healthFocus === "Support for health concern"}
                                    className="form-radio"
                                />
                                <span className="pl-2 mb-2">I need support for a health concern/imbalance</span>

                            </label>
                        </div>
                    </div>

                    <div className="mb-4">
                        <label className="form-question ">
                            2. Are you experiencing any symptoms, diseases, or other health concerns? If yes, please list them below.?
                        </label>
                        <textarea
                            name="symptoms"
                            value={formData.symptoms}
                            onChange={handleChange}
                            rows={3}
                            className="form-textarea"
                        ></textarea>
                    </div>

                    <div className="mb-4">
                        <label className="form-question">
                            3. Your wellness priority?
                        </label>

                        <div className="Wellness-categories-list">
                            {wellnessItems.map((item, index) => (
                                <div key={index} className="form-answer-new flex items-center justify-between w-full">
                                    <div className="flex items-center">
                                        <input
                                            type="checkbox"
                                            name="wellnessAreas"
                                            value={item.name}
                                            checked={item.selected || formData.wellnessAreas.includes(item.name)}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                        />
                                        <img
                                            src={item.imageUrl}
                                            alt={item.name}
                                            className="form-img ml-2"
                                        />
                                        <span className="ml-2">{item.name}</span>
                                    </div>

                                    <ClickAwayListener onClickAway={handleTooltipClose}>
                                        <Tooltip
                                            title={
                                                <>
                                                    <Typography color="inherit" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500, fontSize: "12px" }}>{item.description}</Typography>
                                                    {item.sub_categories?.length > 0 && (
                                                        <List>
                                                            {item.sub_categories.map((subCategory, subIndex) => (
                                                                <ListItem key={subIndex} dense>
                                                                    <Typography variant="body2" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400, fontSize: "10px" }}>
                                                                        {subCategory}
                                                                    </Typography>
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    )}
                                                </>
                                            }
                                            onClose={handleTooltipClose}
                                            open={openTooltipIndex === index}
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            slotProps={{
                                                popper: { disablePortal: true },
                                            }}
                                        >
                                            <IconButton
                                                enterTouchDelay={300}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleTooltipOpen(index);
                                                }}
                                            >
                                                <InfoIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </ClickAwayListener>


                                </div>


                            ))}



                        </div>

                        {
                            wellnessItems.some(item => item.name === "Other" && formData.wellnessAreas.includes(item.name)) && (
                                <input
                                    id="otherWellness"
                                    name="otherWellness"
                                    type="text"
                                    value={formData.otherWellness}
                                    onChange={handleChange}
                                    placeholder="Specify other wellness goals"
                                    className="mt-5 p-2 border border-gray-300 rounded-md w-full mt-2"
                                />
                            )}




                        {/* <div className="mb-4 mt-4">
                    <label htmlFor="otherWellness" className="form-question">
                        Other (specify if not listed)
                    </label>
                    <input
                        id="otherWellness"
                        name="otherWellness"
                        type="text"
                        value={formData.otherWellness}
                        onChange={handleChange}
                        placeholder="Specify other wellness goals"
                        className="w-full p-2 border border-gray-300 rounded-md"
                    />
                </div> */}

                    </div>

                    <div className="mb-4">

                        <label htmlFor="fullName" className="form-question">
                            4. Full Name
                        </label>

                        <input
                            id="fullName"
                            name="fullName"
                            type="text"
                            value={formData.fullName}
                            onChange={handleChange}
                            placeholder="Enter your full name"
                            className="w-full p-2 border border-gray-300 rounded-md"
                        />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="contactNumber" className="form-question">
                            5.  Contact Number/ Email ID
                        </label>
                        <input
                            id="contactNumber"
                            name="contactNumber"
                            type="text"
                            value={formData.contactNumber}
                            onChange={handleChange}
                            placeholder="Enter your contact number/email"
                            className="w-full p-2 border border-gray-300 rounded-md"
                        />
                    </div>

                    <button
                        type="submit"
                        className="submit-button"
                    >
                        Submit
                    </button>
                </div>

            </form>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
};

export default HealthForm;
